import React,{useState} from "react";
import "./style/SwitchButton.css";

const SwitchButton = ({value,setValue}) => {
    const [active, setActive] = useState('left');
  
    return (
      <div className="switch-container">
        <div className="switch-button">
          <div
            className={`switch-toggle switch-left ${active === 'left' ? 'active' : ''}`}
            onClick={() => {
              setActive('left')
              setValue("myStates")
            }}
          >
            MY STATES
          </div>
          <div
            className={`switch-toggle switch-right ${active === 'right' ? 'active' : ''}`}
            onClick={() => {
              setActive('right')
              setValue("allStates")
            }}
          >
            ALL STATES
          </div>
        </div>
      </div>
    );
  };
  
  export default SwitchButton;
